import { render, staticRenderFns } from "./appCardsFiltersMobile.vue?vue&type=template&id=23bdbaa3&scoped=true"
import script from "./appCardsFiltersMobile.vue?vue&type=script&lang=js"
export * from "./appCardsFiltersMobile.vue?vue&type=script&lang=js"
import style0 from "./appCardsFiltersMobile.vue?vue&type=style&index=0&id=23bdbaa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bdbaa3",
  null
  
)

export default component.exports